var map = {
	"./app.json": 14150,
	"./blog.json": 9223,
	"./components.json": 14755,
	"./contratos.json": 47424,
	"./conversionTable.json": 76405,
	"./currency.json": 18244,
	"./currencyBRL.json": 85908,
	"./currencyUSD.json": 89892,
	"./cxi-old.json": 19363,
	"./cxi.json": 75447,
	"./events.json": 69430,
	"./form.json": 51737,
	"./glossary.json": 98947,
	"./home.json": 18612,
	"./iframe.json": 96363,
	"./login.json": 20724,
	"./logout.json": 33013,
	"./matches.json": 14452,
	"./menu.json": 25856,
	"./news.json": 67684,
	"./notifications.json": 2477,
	"./oiweek.json": 12011,
	"./pages.json": 73993,
	"./profile.json": 25368,
	"./ranking-BKP.json": 75299,
	"./ranking.json": 84355,
	"./register.json": 63494,
	"./startup-cxi.json": 25583,
	"./startup.json": 61712,
	"./startupId.json": 96513,
	"./support.json": 50126,
	"./translation.json": 51738,
	"translations/es/app.json": 14150,
	"translations/es/blog.json": 9223,
	"translations/es/components.json": 14755,
	"translations/es/contratos.json": 47424,
	"translations/es/conversionTable.json": 76405,
	"translations/es/currency.json": 18244,
	"translations/es/currencyBRL.json": 85908,
	"translations/es/currencyUSD.json": 89892,
	"translations/es/cxi-old.json": 19363,
	"translations/es/cxi.json": 75447,
	"translations/es/events.json": 69430,
	"translations/es/form.json": 51737,
	"translations/es/glossary.json": 98947,
	"translations/es/home.json": 18612,
	"translations/es/iframe.json": 96363,
	"translations/es/login.json": 20724,
	"translations/es/logout.json": 33013,
	"translations/es/matches.json": 14452,
	"translations/es/menu.json": 25856,
	"translations/es/news.json": 67684,
	"translations/es/notifications.json": 2477,
	"translations/es/oiweek.json": 12011,
	"translations/es/pages.json": 73993,
	"translations/es/profile.json": 25368,
	"translations/es/ranking-BKP.json": 75299,
	"translations/es/ranking.json": 84355,
	"translations/es/register.json": 63494,
	"translations/es/startup-cxi.json": 25583,
	"translations/es/startup.json": 61712,
	"translations/es/startupId.json": 96513,
	"translations/es/support.json": 50126,
	"translations/es/translation.json": 51738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14471;